export default "__VITE_ASSET__f351e98a__"